import { render } from "./IconMail.vue?vue&type=template&id=fe44b18a"
const script = {}

import "./IconMail.vue?vue&type=style&index=0&id=fe44b18a&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__